<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <my-input
            v-model="form.title"
            name="title"
            :error="form.errors.get('title')"
            :autofucos="true"
            class="mb-6"
            label="Job Title"
            placeholder="e.g. Software Developer"
        />
        <div class="flex flex-col space-y-6 md:space-x-2 md:space-y-0 md:flex-row mb-6">
            <my-input
                v-model="form.organization"
                name="organization"
                :error="form.errors.get('organization')"
                label="Organization"
                placeholder="e.g. Microsoft"
            />
            <my-input
                v-model="form.location"
                name="location"
                :error="form.errors.get('location')"
                label="Location"
                placeholder="e.g. Kabul, Afghanistan"
            />
        </div>
        <my-select
            v-model="form.employment_type"
            name="employment_type"
            :error="form.errors.get('employment_type')"
            label="Employment Type"
            class="mb-6"
            placeholder="Select an Employment Type"
            :options="getEmploymentTypes()"
        />
        <div class="flex flex-col space-y-6 md:space-x-2 md:space-y-0 md:flex-row mb-3 w-full">
            <div class="flex-1">
                <month-picker
                    v-model="form.start_date"
                    name="start_date"
                    :error="form.errors.get('start_date')"
                    label="Start Date"
                    class="start-date-picker"
                />
            </div>
            <!-- <div class="ml-2 w-1/2"> -->
            <div class="flex-1">
                <month-picker
                    v-if="!form.is_currently_working"
                    v-model="form.end_date"
                    name="end_date"
                    :error="form.errors.get('end_date')"
                    label="End Date"
                    class="end-date-picker mb-1"
                />
                <label class="flex flex-col w-full">
                    <label v-if="form.is_currently_working" class="font-bold mb-1">End Date</label>
                    <div class="flex text-sm text-gray-600 items-center">
                        <input v-model="form.is_currently_working" class="currently-working mr-1" type="checkbox" />
                        <span>I am currently working in this role.</span>
                    </div>
                </label>
            </div>
        </div>
        <my-textarea v-model="form.description" :error="form.errors.get('description')" name="description" label="Description" />
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        userId: {
            type: String,
            required: true
        },
        updateRec: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            fields: [
                'title',
                'organization',
                'location',
                'description',
                'employment_type',
                'start_date',
                'end_date',
                'is_currently_working'
            ],
            form: null
        };
    },

    watch: {
        'form.is_currently_working': function(val) {
            if (val) {
                this.form.end_date = null;
            }
        }
    },

    mounted() {
        this.initForm();
    },

    methods: {
        initForm() {
            let formData = {};

            if (this.updateRec) {
                this.fields.forEach(field => {
                    formData[field] = this.updateRec[field];
                });
            } else {
                this.fields.forEach(field => {
                    formData[field] = null;
                });
            }

            this.form = new Form(formData);
        },

        getEmploymentTypes() {
            return {
                'Full Time': 'Full Time',
                'Part Time': 'Part Time',
                'Self-Employed': 'Self-Employed',
                Freelance: 'Freelance',
                Contract: 'Contract',
                Internship: 'Internship',
                Apprenticeship: 'Apprenticeship'
            };
        },

        submit() {
            let uri = this.updateRec
                ? `/api/profile/${this.userId}/work-experiences/${this.updateRec.id}`
                : `/api/profile/${this.userId}/work-experiences`;

            return new Promise((resolve, reject) => {
                this.form
                    .post(uri)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
